import {usePageModelsStore} from "@/store/modules/pageModels";
import {useDataSourceStore} from "@/store/modules/dataSourceStore";
import {storeToRefs} from "pinia";
import {ViewModel} from "@/main-page/jsParseEngine/ViewModel";
import {getFlowParams, getFormId, startFlowByFormId} from "../flowDealUtils/flowDealUtils";
import {executeStartFlowFun} from "../server/flowServer";
import GoingUtils from "@/utils/goingUtils";
import {regeditEngineEvent} from "@/main-page/utils/FunctionEngineUtils";

export function useFlowStartHooks({winParams, emits}) {

  const pageModelsStore: any = usePageModelsStore();
  const dataSourceStore: any = useDataSourceStore();
  const {state} = storeToRefs(pageModelsStore);
  const viewModel = new ViewModel({viewPage: {}, pageModelsStore, dataSourceStore, state});
  const saveLoading: any = ref(false);

  const showUserSelectFlag = ref(false);
  const remarkInfo = ref('');
  const userDealList = ref([]);
  const formIdVal = ref('');

  /**
   * 初始化函数引擎
   */
  const initFunctionEngine = function () {
    /**
     * 获取表单对象
     */
    regeditEngineEvent('','getPageFormObj',()=>{
      const formId = getFormId();
      if(formId){
        let formObj:any = viewModel.getFormVuexVal(formId);
        if(formObj==null){
          console.error(formObj,"=========formObj不存在==模糊获取一个form对象，不严谨=");
          pageModelsStore.stateRemarks.forEach((itemRemark)=>{
            if(itemRemark.ctlType==='xmForm'){
              formObj = pageModelsStore.state[itemRemark.value];
              console.error(formObj,"======模糊获取后===formObj");
            }
          })
        }
        return formObj;
      }else{
        GoingUtils.showErrorMessage('部件表单对象不存在，请确认！');
      }
    });

    /**
     * 校验表单对象
     */
    regeditEngineEvent('','validateFormObj',(okFun, errorFun, pageContentElKey) => {
      pageContentElKey = pageContentElKey.split("subPageForm_")[1];
      if (pageContentElKey) {
        const formObj = viewModel.getPageFormObj(pageContentElKey);
        if (formObj) {
          viewModel.validateForm(viewModel.getPageFormObjId(pageContentElKey), async () => {
            okFun && okFun();
          })
        }
      } else {
        const formId = getFormId();
        const formObj = viewModel.getFormVuexVal(formId);
        if (formObj == null) {
          loadingFlag.value = false;
          GoingUtils.showErrorMessage('校验表单对象不存在，请确认！');
          return void (0);
        }
        viewModel.validateForm(formId, async () => {
          okFun && okFun();
        })
      }
    });
  }

  /**
   * 暂存记录
   */
  const saveRecord = function () {
    saveLoading.value = true;
    setTimeout(() => {
      saveLoading.value = false;
    }, 2000);
    const formId = getFormId();
    if (formId) {
      const extendParams = {isTemp: true};
      startFlowByFormId({
        clickEvent: function () {
        }, formId, viewModel, loadingFlag: saveLoading, emits, winParams, extendParams
      });
    }
  }

  const loadingFlag = ref(false);


  /**
   * 发起流程
   */
  const createFlow = function () {
    loadingFlag.value = true;
    setTimeout(() => {
      loadingFlag.value = false;
    }, 2000)
    const formId = getFormId();
    if (formId) {
      const extendParams = {};
      startFlowByFormId({
        clickEvent: function () {
        }, formId, viewModel, loadingFlag, emits, winParams, extendParams, backFun: (res, closFlag = true) => {
          formIdVal.value = formId;
          //显示选人框
          showUserSelectFlag.value = true;
          remarkInfo.value = '当前环节有多个处理人，请选择其中一位再提交！';
          userDealList.value = res.userList;
          if (closFlag) {
            emits('closeWin', {});
          }
        }
      });
    }
  }

  const createFlowBySelUserId = function (selUserIds) {
    if (selUserIds && Array.isArray(selUserIds)) {
      selUserIds = selUserIds.join(";")
    }
    const extendParams = {
      selectUserId: selUserIds
    };
    executeStartFlowFun(getFlowParams({viewModel, formId: unref(formIdVal), winParams, extendParams}), (des) => {
      emits('closeWin', {});
      showUserSelectFlag.value = false;
    })
  }

  return {
    initFunctionEngine,
    showUserSelectFlag,
    userDealList,
    remarkInfo,
    createFlowBySelUserId,
    submitLoadingFlag: loadingFlag,
    createFlow,
    saveLoading,
    saveRecord
  }
}
